export default {"src":"/_next/static/media/goal-dining.ca72ec4f.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};